<template lang="pug">
validation-observer.analise(ref='validation' tag='div')
  app-modal-selecionar-modelo-notificacao(
      :tiposModelo="tiposModelo",
      titulo="Modelos de Despacho",
      v-if="showModalDespacho",
      :showModal="showModalDespacho"
      @closeModal="fecharModalDespacho",
      @setTextoDespacho="setTextoDespacho"
    )
  el-card(shadow='hover' v-if="processo").card-collapse
    el-col(:span='8').center
      app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
      app-display(label="Número do processo:", :content="processo.numeroProcesso")
    el-col(:span='8')
      app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
      app-display(label="Tipo de Processo:", :content="processo.tipo.nome")
    app-opcoes-header-analise.right(
      :idProcesso="processo.id",
      :numeroProcesso="processo.numeroProcesso",
      :tipoProcesso="processo.tipo.codigo",
      :protocolo="processo.numeroProtocolo",
      :idDespacho="idDespacho"
    )

  el-card(shadow="hover",v-if="dadosCadastros").card-collapse
    div
      validation-provider(rules="required", v-slot="{ errors }")
        .flex-despacho
          p.label Despacho
            span.required &nbsp * &nbsp
          el-button(type="primary", @click="openModalDespacho") Modelo &nbsp
            .fa.fa-file

        app-editor-texto.input(
          @onTextChange="onTextChange",
          v-model="textoDespacho",
          :class="{'erro' : errors.length}"
          ref="editorTexto"
        )
        span.help.erro {{ errors[0] }}
      app-anexo(
        :id="'upload-anexo-despacho'",
        @uploadFile="uploadFile",
        :files="anexos",
        @removeFile="removeFile"
        @downloadDocumentoCadastro="downloadDocumentoCadastro",
        :tipoExibir="'ANEXO_ANALISE'"
      )
      app-radios-tramitacao(
        :radios="acoesRadio",
        :isDecisao="isDecisao",
        @changeRadio="changeRadio",
        v-if='showButtonsTramitacao'
      )
  app-buttons-cadastro(
    :isUltimoPasso="true",
    :isPrimeiroPasso="true",
    :showButtonSalvar="false",
    @finalizar="finalizar",
    @cancelar="cancelar"
  )
</template>
<script>

import FileSaver from 'file-saver'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppAnexo from '@/components/AppAnexo'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import axios from '@/utils/api'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppDisplay from '@/components/AppDisplay'
import AppOpcoesHeaderAnalise from './../components/modal/AppOpcoesHeaderAnalise'
import _ from 'lodash'
import acaoProcesso from '@/constants/acaoProcesso'
import AppModalSelecionarModeloNotificacao from './../components/AppModalSelecionarModeloNotificacao'
const { tiposModeloDefault } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppEditorTexto,
    AppButtonsCadastro,
    AppDisplay,
    AppAnexo,
    AppRadiosTramitacao,
    AppOpcoesHeaderAnalise,
    AppModalSelecionarModeloNotificacao
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    idProcesso: {
      required: true
    }
  },

  data () {
    return {
      dadosCadastros: undefined,
      anexos: [],
      textoDespacho: '',
      radios: [],
      acoesRadio: [],
      isDecisao: false, // variavel utilizado para selecionar a decisão de despacho selecionada e enviar para o componente que exibe os radios

      decisao: {},
      hasAnexoDocumento: false,
      hasClickFinalizar: true,
      processo: null,
      showButtonsTramitacao: false,
      showModalDespacho: false,
      idDespacho: undefined,
      tiposModelo: tiposModeloDefault
    }
  },

  async created () {
    this.processo = await this.getProcessoById(this.idProcesso)
    let responseAnalise = await this.iniciaAnaliseProcesso({ idProcesso: this.idProcesso, tipoAcao: acaoProcesso.SOLICITAR_ARQUIVAMENTO })
    this.dadosCadastros = responseAnalise
    let radios = await this.tarefa({ processo: this.idProcesso })
    this.acoesRadio = radios.acoes.filter(acao => acao.valor.includes('ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE') || acao.valor.includes('RETORNO.SISTEMA.ANTERIOR'))
    this.showButtonsTramitacao = true
    this.idDespacho = responseAnalise.despacho.id
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      arquivarProcesso: 'processo/arquivarProcesso',
      retornarSetor: 'processo/retornarSetor',
      tarefa: 'processo/tarefa',
      iniciaAnaliseProcesso: 'processo/iniciaAnalise'
    }),

    changeRadio (value) {
      this.dadosCadastros.despacho.acao = value.acao
      if (value.usuario) {
        this.dadosCadastros.despacho.processo.usuarioEncaminhar = { id: value.usuario }
      }
    },

    async removeFile (documento) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => { })
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(this.anexos.find(a => a.id === documento.id))
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(this.anexos.find(a => a.key === documento.key))
        this.anexos.splice(index, 1)
      }
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },

    cancelar () {
      this.$router.push({
        name: 'AGUARDANDO_OS'
      })
    },

    onTextChange (text) {
      this.textoDespacho = text
    },

    openModalDespacho () {
      if (this.isReurb && (this.processo.setor === 'DEAF' || this.processo.setor === 'DJ' || this.processo.setor === 'GP')) {
        this.tipoModelo = 4
        this.tituloModalModelo = 'Modelo de Despacho Reurb'
      }
      this.showModalDespacho = true
    },

    fecharModalDespacho () {
      this.showModalDespacho = false
    },

    setTextoDespacho (textoDespacho) {
      this.$refs.editorTexto.text = textoDespacho
      this.$refs.editorTexto.emitTextChange()
    },

    async finalizar () {
      if (!this.hasClickFinalizar) {
        return
      }
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, this.$messages.ERROS_ANALISE)
        return
      }

      this.confirmBox(this.$messages.FINALIZAR_ANALISE, this.$messages.TITULO_WARNING,
        async () => {
          try {
            this.hasClickFinalizar = false
            await this.atualizaDocumentos()

            let despacho = {
              idProcesso: this.processo.id,
              acao: this.dadosCadastros.despacho.acao,
              textoDespacho: this.textoDespacho,
              anexos: this.anexos
            }
            if (this.dadosCadastros.despacho.acao === 'RETORNO.SISTEMA.ANTERIOR') {
              this.retornarSetor(despacho)
                .then(() => {
                  this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                    'Processo retornado para o setor anterior')
                  this.$router.push({
                    name: 'AGUARDANDO_OS'
                  })
                })
            }
            if (this.dadosCadastros.despacho.acao === 'ARQUIVAMENTO.SISTEMA.SISTEMA.AUTOCOMPLETE') {
              this.arquivarProcesso(despacho)
                .then(() => {
                  this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                    'Análise finalizada. Processo enviado para o setor DEAF.')
                  this.$router.push({
                    name: 'AGUARDANDO_OS'
                  })
                })
            }
          } catch (error) {
            const erroValidacao = error.status === 422
            const tipoErro = !erroValidacao ? this.$messages.TIPO_ERROR : this.$messages.TIPO_WARNING
            const tituloErro = !erroValidacao ? this.$messages.TITULO_ERROR : this.$messages.TITULO_WARNING
            const messagemDeErro = Array.isArray(error.erros) ? error.erros.join(';') : 'Houve um erro ao salvar a analise.'
            this.showNotificacao(tipoErro, tituloErro, messagemDeErro)
            this.hasClickFinalizar = true
            this.dadosCadastros.despacho.documentos = []
          }
        })
    },

    async atualizaDocumentos () {
      this.dadosCadastros.despacho.documentos = _.cloneDeep(this.anexos)
      await this.dadosCadastros.dadosCadastros.map(dados => {
        if (dados.tipo === 'tabelaComCheck') {
          if (dados && dados.data) {
            dados.data.map(documento => {
              documento.id = null
              this.dadosCadastros.despacho.documentos.push(documento)
            })
          }
        }
      })
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    }
  }
}

</script>
<style lang="scss">
.padding {
  padding: 5px;
}

.required {
  color: firebrick;
}

.flex-despacho {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
}

.container-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label {
  font-weight: bold;
}

.radios-despacho-parecer {
  display: flex;
  justify-content: center;
}

.analise {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.btn-actions {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.flex button {
  margin-bottom: 1em;
}

.flex .el-button span {
  display: flex;
}

.right {
  float: right;
}

.extra-margin-top-bottom {
  margin-top: 30px;
  margin-bottom: 30px;
}

.margin-medium-top {
  margin-top: 20px;
}

.campo {
  margin-top: 2%;
}

.top-georreferenciamento {
  margin-top: 30px;
  text-align: center;
}

.button {
  border: none;
  background: none;
  padding: 0;
}

.button-modal-label {
  font-weight: bold;
  color: #009c66 !important;
}

.button-comIcone span {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/ordemServico/SolicitarArquivamento.vue